import { useAccount } from "context/AccountContext";
import { useState } from "react";
import useData from "hooks/useData";

export const useGroupAccess = () => {
  const { user } = useAccount();
  const { getData, postData, patchData, deleteData } = useData();
  const [ working, setWorking ] = useState(false);

  const checkAccess = async (groupId) => {
    setWorking(true);
    const { data } = await getData(`rest/group/${ groupId }/user`);
    setWorking(false);
    return data;
  }

  const requestAccess = async (groupId, groupMemberId, motivation = null) => {
    setWorking(true);

    if (groupMemberId) {
      return updateAccessRecord(groupMemberId, 'access_requested', motivation);
    }
    else {
      const values = {
        uid: user.id,
        group_id: groupId,
        motivation: motivation
      }
      const response = await postData(`rest/group_member`, values, false);
      setWorking(false);
      return response;
    }
  }

  const updateAccessRecord = async (id, status, motivation = null) => {
    setWorking(true);
    const values = {
      status: status,
      motivation: motivation
    };
    const response = await patchData(id, 'group_member', values, false);
    setWorking(false);
    return response;
  }

  const deleteAccessRecord = async (groupMemberId) => {
    setWorking(true);
    const response = await deleteData(`rest/group_member/${ groupMemberId }`, false);
    setWorking(false);
    return response;
  }

  const denyAccess = (groupMemberId, motivation) => {
    return updateAccessRecord(groupMemberId, 'access_denied', motivation);
  }

  const removeAccess = (groupMemberId, motivation = null) => {
    return updateAccessRecord(groupMemberId, 'removed', motivation);
  }

  const allowAccess= (groupMemberId) => {
    return updateAccessRecord(groupMemberId, 'is_member');
  }

  const leaveGroup = async (groupMemberId) => {
    return deleteAccessRecord(groupMemberId);
  }

  return { working, checkAccess, requestAccess, removeAccess, denyAccess, allowAccess, leaveGroup };
};
